export enum ERole {
  ROLE_ADMIN = "ROLE_ADMIN",
  ROLE_COMPANY = "ROLE_COMPANY",
  ROLE_PROJECT_MANAGER = "ROLE_PROJECT_MANAGER",
  ROLE_WORKER = "ROLE_WORKER",
  ROLE_CUSTOMER = "ROLE_CUSTOMER",
  ROLE_BUSINESS_PARTNER = "ROLE_BUSINESS_PARTNER",
  ROLE_USER = "ROLE_USER",
}

export enum EWebUserRole {
  ROLE_PROJECT_MANAGER = "ROLE_PROJECT_MANAGER",
  ROLE_WORKER = "ROLE_WORKER",
  ROLE_CUSTOMER = "ROLE_CUSTOMER",
  ROLE_BUSINESS_PARTNER = "ROLE_BUSINESS_PARTNER",
}
